import { CheckCircleFilled, LockOutlined } from '@ant-design/icons';
import colorTokens from '../../constants/design_system/colors';
import { WORKSPACE_VISIBILITY } from '../../pages/Onboarding/WorkspaceOnboarding';
import CompanyLogoSvg from '../../assets/icons/company-logo.svg?react';

export type SpaceVisibilityCardProps = {
  visibility: WORKSPACE_VISIBILITY;
  selected: boolean;
  current: boolean;
  onSelected: (visibility: WORKSPACE_VISIBILITY) => void;
};

export const SpaceVisibilityCard = (props: SpaceVisibilityCardProps) => {
  const title = props.visibility === WORKSPACE_VISIBILITY.Public ? 'Public' : 'Private';
  const subtitle =
    props.visibility === WORKSPACE_VISIBILITY.Public
      ? 'Public spaces are discoverable by everyone in your organization, who can join them.'
      : 'Private spaces are only visible to their members who join upon invitation.';
  const icon =
    props.visibility === WORKSPACE_VISIBILITY.Public ? (
      <CompanyLogoSvg className="w-4 h-4 text-neutral-900" />
    ) : (
      <LockOutlined className="text-neutral-900" />
    );

  return (
    <div
      style={{ borderColor: props.selected ? colorTokens.blue[600] : colorTokens.neutral[300] }}
      className="px-4 py-3 rounded-lg border-solid border-2 border-blue-600 flex-col justify-start items-start gap-3 grow basis-1/2 cursor-pointer"
      onClick={() => props.onSelected(props.visibility)}
    >
      <div className="w-full justify-between items-center inline-flex">
        <div className="justify-start items-center gap-2 flex">
          {icon}
          <div className="flex items-center gap-1 text-brand-grey-dark text-base font-semibold leading-normal">
            {title}
            {props.current && <div className="text-neutral-800 text-xs font-normal leading-none">(current)</div>}
          </div>
        </div>
        {props.selected && <CheckCircleFilled style={{ fontSize: '16px' }} className="text-blue-500" />}
        {!props.selected && <div className="w-[14px] h-[14px] rounded-lg border border-solid border-neutral-600" />}
      </div>
      <div className="self-stretch text-neutral-900 text-xs font-normal leading-none">{subtitle}</div>
    </div>
  );
};
